import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayTatCaGroup(payload) {
    return HTTP({
        url: ENDPOINT.GROUP.ALL,
        method: "GET",
        params: payload
    });
}

export function callApiLayDanhSachGroupPaging(payload) {
    return HTTP({
        url: ENDPOINT.GROUP.SEARCH,
        method: "POST",
        data: payload
    });
}

export function callApiLayChiTietGroup(payload) {
    return HTTP({
        url: ENDPOINT.GROUP.DETAIL,
        method: "GET",
        params: payload
    });
}

// T4+5 UC13.4: đếm user exempt bị ảnh hưởng khi bật mandate OTP cho nhóm. payload = { groupId }.
export function callApiAffectedOtpUsersGroup(payload) {
    return HTTP({
        url: ENDPOINT.GROUP.AFFECTED_OTP_USERS,
        method: "GET",
        params: payload
    });
}

export function callApiLayDanhSachVaiTroTheoGroup(payload) {
    return HTTP({
        url: ENDPOINT.ROLE.DANH_SACH_VAI_TRO_THEO_GROUP,
        method: "GET",
        params: payload
    });
}

export function callApiLayDanhSachQuyenTheoGroup(payload) {
    return HTTP({
        url: ENDPOINT.PERMISSION.DANH_SACH_QUYEN_THEO_GROUP,
        method: "GET",
        params: payload
    });
}

export function callApiLayDanhSachUserNotInGroup(payload) {
    return HTTP({
        url: ENDPOINT.USER.DANH_SACH_NGUOI_DUNG_NOT_IN_GROUP,
        method: "GET",
        params: payload
    });
}

export function callApiThemMoiGroup(payload, endpoint) {
    return new Promise((resolve, reject) => {
        return HTTP.post(`${endpoint}`, payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}


// export function callApiCapNhatGroup(payload) {
//     return HTTP({
//         url: ENDPOINT.GROUP.UPDATE,
//         method: "PUT",
//     });
// }

export function callApiCapNhatGroup(payload, endpoint) {
    return new Promise((resolve, reject) => {
        return HTTP.put(`${endpoint}`, payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function callApiCapNhatQuyenTrongGroup(payload) {
    return new Promise((resolve, reject) => {
        return HTTP.post(ENDPOINT.GROUP.CAP_NHAT_QUYEN_TRONG_GROUP, payload)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function callApiAddMapping(payload) {
    return new Promise((resolve, reject) => {
        return HTTP.post(ENDPOINT.GROUP.ADD_MAPPING, payload)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function callApiRemoveMapping(payload) {
    return new Promise((resolve, reject) => {
        return HTTP.post(ENDPOINT.GROUP.REMOVE_MAPPING, payload)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
export function callApiXoaGroup(payload) {
    // return new Promise((resolve, reject) => {
    //     return HTTP.delete(ENDPOINT.GROUP.DELETE, payload)
    //         .then((response) => {
    //             resolve(response);
    //         })
    //         .catch((error) => {
    //             reject(error);
    //         });
    // });
        return HTTP({
        url: ENDPOINT.GROUP.DELETE,
        method: "DELETE",
        params: payload
    });
}


// export function callApiXoaApp(payload) {
//     return HTTP({
//         url: ENDPOINT.APP.CRUD,
//         method: "DELETE",
//         params: payload
//     });
// }

// export function callApiCapNhatThuTu(payload) {
//     return HTTP({
//       url: ENDPOINT.APP.ORDER,
//       method: "PATCH",
//       data: payload
//     });
//   }